import { Color } from 'chart.js'

export interface TChartPallete {
	correct: Color
	incorrect: Color
	none: Color
	zero: Color
}

export type TPalleteType = 'border' | 'filling'

export interface IChartValues {
	noneAnswerLabel: string
	hiddenAnswersLabels: Array<string>
	possibleLabels: Array<string>
	correctPrefix: string
	borderRadius: number
	minBarLength: number
	pallete: Record<TPalleteType, TChartPallete>
}

const chartValues: IChartValues = {
	noneAnswerLabel: 'None',
	hiddenAnswersLabels: ['✓Correct', 'Incorrect'],
	possibleLabels: ['A', 'B', 'C', 'D'],
	correctPrefix: '✓',
	borderRadius: 4,
	minBarLength: 4,
	pallete: {
		border: {
			correct: 'rgb(95, 213, 152)',
			incorrect: 'rgb(242, 108, 89)',
			none: 'rgb(184, 192, 198)',
			zero: '#8B9195',
		},
		filling: {
			correct: 'rgba(143, 226, 183, 0.7)',
			incorrect: 'rgba(246, 152, 139, 0.7)',
			none: 'rgba(205, 211, 215, 0.7)',
			zero: '#8B9195',
		},
	},
}

export default chartValues
